export const manifestUrl = '/webforma-services/getManifest';
